module.exports = __webpack_public_path__ + "img/11n.99e32ebf.png";